// ============================================================
// AccordionTab — replaces p-accordion / p-accordionTab from PrimeNG
// ============================================================
import React, { useState } from 'react';

interface AccordionTabProps {
  header: React.ReactNode;
  children: React.ReactNode;
  defaultOpen?: boolean;
}

const AccordionTab: React.FC<AccordionTabProps> = ({
  header,
  children,
  defaultOpen = false,
}) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="accordion-tab-wrapper">
      <div
        className="accordion-tab-header"
        onClick={() => setOpen((prev) => !prev)}
        style={{ cursor: 'pointer', userSelect: 'none' }}
      >
        {header}
        <span style={{ marginLeft: 8, fontSize: 12, color: '#666' }}>
          {open ? '▲' : '▼'}
        </span>
      </div>
      {open && <div className="accordion-tab-body p-2">{children}</div>}
    </div>
  );
};

export default AccordionTab;
